import { GuideStep } from './StepByStepGuide';

export const TOUR_DEFINITIONS: Record<string, GuideStep[]> = {
  modelosContrato: [
    {
      target: '[data-tour="btn-cadastrar"]',
      title: 'Novo modelo',
      description: 'Clique em "Cadastrar" para criar seu modelo de contrato',
      action: 'click',
    },
    {
      target: '[data-tour="campo-titulo"]',
      title: 'Título',
      description: 'Informe o título do modelo (ex: "Contrato Padrão")',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-descricao"]',
      title: 'Descrição',
      description: 'Adicione uma descrição para identificar o modelo',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para ir ao editor de documento',
      action: 'click',
    },
  ],

  veiculos: [
    // Página 1 - Identificação
    {
      target: '[data-tour="btn-cadastrar"]',
      title: 'Novo veículo',
      description: 'Clique em "Cadastrar" para adicionar um veículo',
      action: 'click',
    },
    {
      target: '[data-tour="campo-placa"]',
      title: 'Placa',
      description: 'Informe a placa do veículo para buscar os dados automaticamente',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-tipoVeiculo"]',
      title: 'Tipo',
      description: 'Selecione o tipo do veículo (Carro, Moto ou Caminhão)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-marca"]',
      title: 'Marca',
      description: 'Selecione a marca do veículo pela tabela FIPE',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-modelo"]',
      title: 'Modelo',
      description: 'Selecione o modelo do veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-ano"]',
      title: 'Ano',
      description: 'Informe o ano do veículo para buscar o valor FIPE',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para informar os dados adicionais',
      action: 'click',
    },
    // Página 2 - Dados
    {
      target: '[data-tour="campo-renavam"]',
      title: 'Renavam',
      description: 'Informe o Renavam do veículo (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-chassi"]',
      title: 'Chassi',
      description: 'Informe o número do chassi (opcional, preenchido automaticamente pela placa)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-hodometro"]',
      title: 'Hodômetro',
      description: 'Informe a quilometragem atual do veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-vencimentoLicenciamento"]',
      title: 'Venc. do Licenciamento',
      description: 'Informe a data de vencimento do licenciamento do veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-cor"]',
      title: 'Cor',
      description: 'Selecione a cor do veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para informar o investimento',
      action: 'click',
    },
    // Página 3 - Investimento
    {
      target: '[data-tour="campo-custo"]',
      title: 'Investimento',
      description: 'Informe o valor investido na compra do veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-dataCompra"]',
      title: 'Data da Compra',
      description: 'Informe a data em que o veículo foi adquirido',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para a documentação',
      action: 'click',
    },
    // Página 4 - Documentação
    {
      target: '[data-tour="campo-imagem"]',
      title: 'Foto do Veículo',
      description: 'Adicione uma foto do veículo (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-documento"]',
      title: 'Documento',
      description: 'Anexe um documento do veículo, como CRLV (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Salvar',
      description: 'Clique em "Salvar" para finalizar o cadastro do veículo',
      action: 'click',
    },
  ],

  locatarios: [
    // Página 1 - Identificação
    {
      target: '[data-tour="btn-cadastrar"]',
      title: 'Novo locatário',
      description: 'Clique em "Cadastrar" para adicionar um locatário',
      action: 'click',
    },
    {
      target: '[data-tour="campo-nome"]',
      title: 'Nome',
      description: 'Informe o nome completo do locatário',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-tipoDocumento"]',
      title: 'Documento',
      description: 'Selecione CPF ou CNPJ',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-documento"]',
      title: 'Número',
      description: 'Informe o número do documento',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-rg"]',
      title: 'RG',
      description: 'Informe o RG do locatário',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-vencimentoHabilitacao"]',
      title: 'Vencimento da Habilitação',
      description: 'Informe a data de vencimento da CNH do locatário',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para informar o contato',
      action: 'click',
    },
    // Página 2 - Contato
    {
      target: '[data-tour="campo-email"]',
      title: 'Email',
      description: 'Informe o email do locatário. Este email é usado para assinatura digital e comunicação, não é o login do app.',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-telefone"]',
      title: 'Telefone',
      description: 'Informe o telefone do locatário',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para informar o endereço',
      action: 'click',
    },
    // Página 3 - Endereço
    {
      target: '[data-tour="campo-cep"]',
      title: 'CEP',
      description: 'Informe o CEP para preencher o endereço automaticamente',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-numero"]',
      title: 'Número',
      description: 'Informe o número do endereço',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para a documentação',
      action: 'click',
    },
    // Página 4 - Documento
    {
      target: '[data-tour="campo-documentoCNH"]',
      title: 'CNH',
      description: 'Anexe a CNH do locatário (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Salvar',
      description: 'Preencha os dados e clique em "Salvar" para finalizar o cadastro',
      action: 'click',
    },
    // Após salvar - guiar para criar acesso no app
    {
      target: '[data-tour="btn-menu-acoes"]',
      title: 'Criar acesso do locatário',
      description: 'Agora clique no menu de ações (três pontos) do locatário que você acabou de cadastrar',
      action: 'click',
    },
    {
      target: '[data-tour="acao-login-no-app"]',
      title: 'Login no APP',
      description: 'Clique em "Login no APP" para criar o acesso do locatário. Ele poderá baixar o app no Android (Google Play) e iOS (App Store). Importante: o locatário só deve fazer login após você criar uma locação para ele!',
      action: 'click',
    },
  ],

  locacoes: [
    // Página 1 - Dados
    {
      target: '[data-tour="campo-idVeiculo"]',
      title: 'Veículo',
      description: 'Selecione o veículo que será locado',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-idLocatario"]',
      title: 'Locatário',
      description: 'Selecione o locatário que irá alugar o veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para configurar o contrato',
      action: 'click',
    },
    // Página 2 - Contrato
    {
      target: '[data-tour="campo-kmInicial"]',
      title: 'Quilometragem Inicial',
      description: 'Informe a quilometragem atual do veículo no momento da entrega',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-periodicidadePagamento"]',
      title: 'Periodicidade do Pagamento',
      description: 'Defina como você receberá: Mensal, Quinzenal, Semanal ou Diário',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-locacaoEmAndamento"]',
      title: 'Locação em Andamento',
      description: 'Marque se esta locação já está em andamento (ex: Essa locação existia antes de você começar a utilizar o LocaSmartPro)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-tempoContratoEmMeses"]',
      title: 'Prazo Mínimo',
      description: 'Defina o prazo mínimo do contrato de locação para que possamos gerar automaticamente os pagamentos previstos. Posteriormente, o contrato poderá ser prorrogado, se necessário.',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-fiador"]',
      title: 'Fiador',
      description: 'Informe o nome do fiador, somente houver (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-opcaoDeCompra"]',
      title: 'Opção de Compra',
      description: 'Marque esta opção caso o contrato preveja a possibilidade de compra do veículo ao final da locação, ou seja, se houver a opção de o veículo ser transferido para o locatário ao término do contrato.',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para definir os valores',
      action: 'click',
    },
    // Página 3 - Valores
    {
      target: '[data-tour="campo-valorAluguel"]',
      title: 'Valor do Aluguel',
      description: 'Informe o valor do aluguel por período',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-valorCaucao"]',
      title: 'Valor da Caução',
      description: 'Informe o valor da caução/garantia (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-dataInicio"]',
      title: 'Data de Retirada',
      description: 'Informe a data em que o locatário retira o veículo',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-dataPagamento"]',
      title: 'Data do Primeiro Pagamento',
      description: 'Defina a data do primeiro pagamento do aluguel. Essa informação é essencial, pois as próximas cobranças serão geradas automaticamente com base nessa data.',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para configurar juros e multa',
      action: 'click',
    },
    // Página 4 - Juros e Multa
    {
      target: '[data-tour="campo-jurosEscolha"]',
      title: 'Tipo de Juros',
      description: 'Escolha entre juros por dia ou juros ao mês para atrasos',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-valorJurosAoDia"]',
      title: 'Valor dos Juros',
      description: 'Informe o valor dos juros por atraso (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-multaEscolha"]',
      title: 'Tipo de Multa',
      description: 'Escolha entre multa percentual ou valor fixo',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-multaPercentual"]',
      title: 'Valor da Multa',
      description: 'Informe o percentual ou valor fixo da multa por atraso (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para as opções de lançamentos iniciais',
      action: 'click',
    },
    // Página 5 - Lançamentos Iniciais
    {
      target: '[data-tour="campo-gerarPagamentoInicialComoPago"]',
      title: 'Primeiro Pagamento',
      description: 'Marque se você já recebeu o primeiro pagamento do aluguel',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-gerarLancamentoCaucaoComoPago"]',
      title: 'Caução Recebida',
      description: 'Marque se você já recebeu o valor da caução',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para anexar o contrato',
      action: 'click',
    },
    // Página 6 - Arquivo
    {
      target: '[data-tour="campo-contratoEscolha"]',
      title: 'Tipo de Contrato',
      description: 'Você tem duas opções: "Anexar Contrato" para subir um PDF pronto, ou "Gerar Contrato" para criar automaticamente a partir do modelo que você configurou na primeira etapa (Criar Modelo de Contrato). Recomendamos "Gerar Contrato" para praticidade!',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-modeloContrato"]',
      title: 'Modelo de Contrato',
      description: 'Selecione o modelo de contrato que você configurou na primeira etapa dos Primeiros Passos. O contrato será gerado automaticamente com todos os dados da locação preenchidos.',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Salvar',
      description: 'Clique em "Salvar" para finalizar a locação. Os pagamentos serão gerados automaticamente!',
      action: 'observe',
    },
  ],

  pagamentosBaixados: [
    {
      target: '[data-tour="filtro-locacao"]',
      title: 'Selecionar Locação',
      description: 'Selecione uma locação para filtrar os pagamentos do locatário desejado. Após selecionar, clique em "Próximo"',
      action: 'observe',
      shield: false,
    },
    {
      target: '[data-tour="btn-buscar-pagamento"]',
      title: 'Buscar Pagamentos',
      description: 'Clique em "Buscar" para carregar os pagamentos da locação selecionada',
      action: 'click',
    },
    {
      target: '[data-tour="acao-confirmar/editar-pagamento"]',
      title: 'Confirmar/Editar Pagamento',
      description: 'Clique neste botão para abrir a tela de confirmação e dar baixa no pagamento',
      action: 'click',
    },
    {
      target: '[data-tour="campo-valor-recebido"]',
      title: 'Valor Recebido',
      description: 'Informe o valor que você recebeu. Se for menor que o valor total, você poderá gerar uma pendência para o restante',
      action: 'observe',
    },
    {
      target: '[data-tour="opcoes-avancadas"]',
      title: 'Opções Avançadas',
      description: 'Clique aqui para acessar opções como alterar vencimento ou gerar pendência de valor não recebido',
      action: 'click',
    },
    {
      target: '[data-tour="gerar-pendencia"]',
      title: 'Gerar Pendência',
      description: 'Marque esta opção para gerar uma pendência. Útil quando o locatário paga parcialmente ou quando há juros/multas a cobrar separadamente',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-confirmar-pagamento"]',
      title: 'Confirmar Pagamento',
      description: 'Clique em "Confirmar Pagamento" para dar baixa. Se marcou gerar pendência, um novo pagamento pendente será criado automaticamente!',
      action: 'observe',
    },
  ],

  lancamentos: [
    // Página 1 - Dados
    {
      target: '[data-tour="btn-cadastrar"]',
      title: 'Novo lançamento',
      description: 'Clique em "Novo" para criar um lançamento',
      action: 'click',
    },
    {
      target: '[data-tour="campo-valor"]',
      title: 'Valor',
      description: 'Informe o valor do lançamento',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-tipo"]',
      title: 'Tipo',
      description: 'Selecione se é Entrada (receita) ou Saída (despesa)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-status"]',
      title: 'Status',
      description: 'Defina se o lançamento já foi resolvido (pago/recebido) ou se está pendente',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-dataRealizado"]',
      title: 'Data de Vencimento',
      description: 'Informe a data de vencimento do lançamento',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para detalhar o lançamento',
      action: 'click',
    },
    // Página 2 - Detalhamento
    {
      target: '[data-tour="campo-categorias"]',
      title: 'Categorias',
      description: 'Selecione até 2 categorias para classificar o lançamento (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-descricao"]',
      title: 'Observação',
      description: 'Descreva o lançamento para facilitar a identificação (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para vincular a uma locação ou veículo',
      action: 'click',
    },
    // Página 3 - Vínculos
    {
      target: '[data-tour="campo-idLocacao"]',
      title: 'Locação',
      description: 'Vincule a uma locação existente (opcional). Ao vincular, o veículo será preenchido automaticamente',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-idVeiculo"]',
      title: 'Veículo',
      description: 'Vincule a um veículo (opcional). Preenchido automaticamente se vinculou a uma locação',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para opções adicionais',
      action: 'click',
    },
    // Página 4 - Adicionais
    {
      target: '[data-tour="campo-desejoRepetirLancamento"]',
      title: 'Repetir em Parcelas',
      description: 'Marque se deseja repetir este lançamento em parcelas. Útil para despesas recorrentes como seguro ou rastreador',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Salvar',
      description: 'Anexe um arquivo ou imagem se desejar e clique em "Salvar" para finalizar o lançamento',
      action: 'observe',
    },
  ],

  manutencoes: [
    // Página 1 - Tipo
    {
      target: '[data-tour="btn-cadastrar"]',
      title: 'Nova manutenção',
      description: 'Clique em "Cadastrar" para registrar uma manutenção',
      action: 'click',
    },
    {
      target: '[data-tour="campo-tipoManutencao"]',
      title: 'Tipo',
      description: 'Selecione "Manutenção" para registrar um serviço já realizado, ou "Ordem de Serviço" para agendar um serviço futuro',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para selecionar o veículo',
      action: 'click',
    },
    // Página 2 - Veículo
    {
      target: '[data-tour="campo-idVeiculo"]',
      title: 'Veículo',
      description: 'Selecione o veículo que receberá a manutenção',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-hodometro"]',
      title: 'Hodômetro',
      description: 'Informe a quilometragem atual do veículo. Isso ajuda a planejar as próximas manutenções automaticamente',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para adicionar peças',
      action: 'click',
    },
    // Página 3 - Peças: botão de criar nova peça
    {
      target: '[data-tour="selectgrid-btn-novo"]',
      title: 'Cadastrar Nova Peça',
      description: 'Vamos cadastrar uma peça! Clique neste botão verde para abrir o formulário de cadastro',
      action: 'click',
      shield: false,
    },
    // Dentro do modal de criar peça
    {
      target: '[data-tour="campo-tipoVeiculo"]',
      title: 'Tipo do Veículo',
      description: 'Selecione para qual tipo de veículo esta peça se aplica: Carro, Moto ou Ambos',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-nome"]',
      title: 'Nome da Peça',
      description: 'Informe o nome da peça (ex: "Pastilha de Freio", "Filtro de Óleo")',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-marca"]',
      title: 'Marca',
      description: 'Informe a marca da peça',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-modelo"]',
      title: 'Modelo/Número',
      description: 'Informe o modelo ou número de referência da peça',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-vidaUtilEmKm"]',
      title: 'Vida Útil (KM)',
      description: 'Informe a vida útil em quilômetros (opcional). Permite planejar automaticamente quando trocar novamente',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-salvar"]',
      title: 'Salvar Peça',
      description: 'Clique em "Salvar" para cadastrar a peça. Ela ficará disponível para uso nesta e em futuras manutenções',
      action: 'click',
      shield: false,
    },
    // Volta para a página de peças — selecionar a peça no dropdown
    {
      target: '[data-tour="selectgrid-inserir"]',
      title: 'Selecionar a Peça',
      description: 'Agora clique aqui e selecione a peça que acabou de cadastrar na lista',
      action: 'click',
      shield: false,
    },
    // Dentro do modal de inserção — preencher quantidade e valor
    {
      target: '[data-tour="selectgrid-campo-qtdEstoque"]',
      title: 'Quantidade Utilizada',
      description: 'Informe quantas unidades desta peça foram utilizadas na manutenção',
      action: 'observe',
    },
    {
      target: '[data-tour="selectgrid-campo-valor"]',
      title: 'Preço da Unidade',
      description: 'Informe o preço unitário da peça. Peças do estoque terão valor zerado automaticamente',
      action: 'observe',
    },
    {
      target: '[data-tour="selectgrid-btn-salvar"]',
      title: 'Confirmar Peça',
      description: 'Clique para inserir a peça na manutenção',
      action: 'click',
      shield: false,
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para adicionar os serviços realizados',
      action: 'click',
    },
    // Página 4 - Serviços: botão de criar novo serviço
    {
      target: '[data-tour="selectgrid-btn-novo"]',
      title: 'Cadastrar Novo Serviço',
      description: 'Vamos cadastrar um serviço! Clique neste botão verde para abrir o formulário',
      action: 'click',
      shield: false,
    },
    // Dentro do modal de criar serviço
    {
      target: '[data-tour="campo-nome"]',
      title: 'Nome do Serviço',
      description: 'Informe o nome do serviço (ex: "Troca de Óleo", "Alinhamento e Balanceamento")',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-valor"]',
      title: 'Valor do Serviço',
      description: 'Informe o valor base. Será sugerido nas próximas manutenções, mas pode ser ajustado',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-periodoEmKm"]',
      title: 'Periodicidade em KM',
      description: 'A cada quantos KM refazer esse serviço (opcional). A IA usará para alertar sobre a próxima manutenção',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-salvar"]',
      title: 'Salvar Serviço',
      description: 'Clique em "Salvar" para cadastrar o serviço',
      action: 'click',
      shield: false,
    },
    // Volta para a página de serviços — selecionar o serviço no dropdown
    {
      target: '[data-tour="selectgrid-inserir"]',
      title: 'Selecionar o Serviço',
      description: 'Clique aqui e selecione o serviço que acabou de cadastrar na lista',
      action: 'click',
      shield: false,
    },
    // Dentro do modal de inserção — ajustar valor
    {
      target: '[data-tour="selectgrid-campo-valor"]',
      title: 'Valor Cobrado',
      description: 'Ajuste o valor cobrado por este serviço nesta manutenção, se necessário',
      action: 'observe',
    },
    {
      target: '[data-tour="selectgrid-btn-salvar"]',
      title: 'Confirmar Serviço',
      description: 'Clique para inserir o serviço na manutenção',
      action: 'click',
      shield: false,
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para preencher as informações da manutenção',
      action: 'click',
    },
    // Página 5 - Informações
    {
      target: '[data-tour="campo-valor"]',
      title: 'Valor Total',
      description: 'Valor total calculado automaticamente com base nas peças e serviços. Ajuste manualmente se necessário',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-parcelas"]',
      title: 'Forma de Pagamento',
      description: 'Selecione se foi à vista ou parcelado (até 12x)',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-dataRealizado"]',
      title: 'Data Realizada',
      description: 'Data em que o serviço foi concluído. As próximas manutenções serão planejadas a partir desta data',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-dataPagamento"]',
      title: 'Data do Pagamento',
      description: 'Data em que o pagamento foi realizado. Parcelas serão contabilizadas a partir daqui',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-idPrestadorServico"]',
      title: 'Prestador / Fornecedor',
      description: 'Quem realizou o serviço (oficina, mecânico, fornecedor). Se não tiver cadastrado, selecione "AVULSO"',
      action: 'observe',
    },
    {
      target: '[data-tour="campo-descricao"]',
      title: 'Descrição',
      description: 'Descreva detalhes adicionais da manutenção (opcional)',
      action: 'observe',
    },
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Avançar',
      description: 'Clique em "Avançar" para anexar arquivos',
      action: 'click',
    },
    // Página 6 - Arquivos
    {
      target: '[data-tour="btn-avancar"]',
      title: 'Salvar',
      description: 'Anexe garantia, recibo ou foto (opcional) e clique em "Salvar" para finalizar a manutenção',
      action: 'observe',
    },
  ],
};
